import React, {useEffect, useState} from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import customDataService from "../../../services/customDataService.js";
import utilsHelper from "../../../helpers/utilsHelper.js";
import {useNavigate} from "react-router-dom";
import ModalCustomFieldGroup from "./ModalCustomFieldGroup.js";
import LoadingContent from "../../public/LoadingContent.js";
import usePageAuthorization from "../../../helpers/usePageAuthorization.js";

const ListCustomFieldsGroups = () => {

    const titleSingular = 'Grupo de Campos Personalizados';
    const titlePlural = 'Campos Personalizados';

    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingModal, setEditingModal] = useState(null);
    const navigateTo = useNavigate();
    const [loading, setLoading] = useState(true);

    const { isAuthorized, isSuperAdmin } = usePageAuthorization({
        allowedRoles: ['Admin'],
        setLoading,
    });

    useEffect(() => {
        if(isAuthorized){
            loadingContent();
        }
    },[isAuthorized]);

    const loadingContent = () => {
        setLoading(true);
        customDataService.getCustomDataGroups().then(data => {
            setData(data);
            setLoading(false);
        });
    }

    const handleCreate = () => {
        setEditingModal(null);
        setIsModalOpen(true);
    };

    const handleEdit = (data) => {
        setEditingModal(data);
        setIsModalOpen(true);
    };

    const handleDelete = async (itemId) => {
        if(window.confirm("¿Seguro que deseas eliminar este grupo?")) {
            await customDataService.deleteCustomDataGroups(itemId);
            loadingContent()
        }
    };

    const handleCustomFields = (item) => {
        navigateTo('/datos-personalizados/' + item.id, {
            state: item
        });
    };

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">

                {isModalOpen && (
                    <ModalCustomFieldGroup
                        onClose={() => setIsModalOpen(false)}
                        isModalOpen={isModalOpen}
                        editingModal={editingModal}
                        loadingContent={loadingContent}
                        titleSingular={titleSingular}
                    />
                )}

                <SidebarNav/>

                <div className="p-4 content-container col-md-9 col-lg-10">

                    {loading && (
                        <LoadingContent/>
                    )}

                    {!isAuthorized && (
                        <div>No tienes permiso para ver esta página.</div>
                    )}

                    {!loading && isAuthorized && (
                        <div>
                            <h3 className="mb-4">
                                <i className="bi bi-ui-checks-grid"></i>  Administración de Grupos de {titlePlural}
                            </h3>
                            <button className="btn btn-primary mb-3" onClick={handleCreate}>
                                Crear Nuevo Grupo
                            </button>
                            <table className="table table-striped corner-radius">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Creado</th>
                                    <th>Actualizado</th>
                                    <th className="text-center">En Programas</th>
                                    <th className="text-center">En Tareas</th>
                                    <th className="text-center">Seleccionable</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.group_name}</td>
                                        <td>{utilsHelper.formatDate(item.created_at, true)}</td>
                                        <td>{utilsHelper.formatDate(item.updated_at, true)}</td>
                                        <td className="text-center">{item.is_project_joined ? 'Sí': 'No'}</td>
                                        <td className="text-center">{item.is_task_joined ? 'Sí': 'No'}</td>
                                        <td className="text-center">{item.is_selectable ? 'Sí': 'No'}</td>
                                        <td>
                                            <button
                                                className="btn btn-success btn-sm me-2"
                                                onClick={() => handleCustomFields(item)}>
                                                Editar Campos
                                            </button>
                                            <button
                                                className="btn btn-warning btn-sm me-2"
                                                onClick={() => handleEdit(item)}>
                                                Editar
                                            </button>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(item.id)}>
                                                Borrar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ListCustomFieldsGroups;